var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    class: [{
      loaded: _vm.loaded
    }, '-mt-10 sm-md:mt-0']
  }, [_c('loading-overlay', {
    attrs: {
      "wait-for": !_vm.loaded
    }
  }), _vm._v(" "), _c('section', {
    staticClass: "dash--section"
  }, [_c('div', {
    staticClass: "section--container"
  }, [_c('div', {
    staticClass: "container max-w-3xl section--content"
  }, [_vm.hasToken ? _c('div', [_vm.hasLockedUser ? _c('div', [_c('img', {
    staticClass: "w-12 mb-8",
    attrs: {
      "src": require("assets/images/suture_wand.svg")
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "sm-md:h2"
  }, [_vm._v("We’re ready to switch")]), _vm._v(" "), _c('p', {
    staticClass: "my-4 text-lg leading-8"
  }, [_vm._v("\n\t\t\t\t\t\t\tTap the button below to open the Extra App and you’ll be able to switch your bank\n\t\t\t\t\t\t\taccount faster than you can say “My debit card builds credit, how about yours?”\n\t\t\t\t\t\t")]), _vm._v(" "), _vm._m(0)]) : _c('div', [_c('h1', {
    staticClass: "sm-md:h2"
  }, [_vm._v("Uh-oh")]), _vm._v(" "), _vm._m(1)])]) : _c('div', [_c('p', {
    staticClass: "my-8 text-xl leading-8 text-center"
  }, [_vm._v("\n\t\t\t\t\t\tClick the button in the email you recieved from Extra Member Concierge to continue\n\t\t\t\t\t")])])])])])], 1);
};
var staticRenderFns = [function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('a', {
    attrs: {
      "href": "extra://"
    }
  }, [_c('button', {
    staticClass: "my-4"
  }, [_vm._v("Open The Extra App")])]);
}, function () {
  var _vm = this,
    _c = _vm._self._c;
  return _c('p', {
    staticClass: "my-4 text-lg leading-8"
  }, [_vm._v("\n\t\t\t\t\t\t\tLooks like something went wrong on our end, or your one time switch link has already\n\t\t\t\t\t\t\tbeen redeemed. In both cases, contact Member Concierge at\n\t\t\t\t\t\t\t"), _c('a', {
    attrs: {
      "href": "mailto:hey@extra.app"
    }
  }, [_vm._v("hey@extra.app")]), _vm._v(".\n\t\t\t\t\t\t")]);
}];
export { render, staticRenderFns };